import { render, staticRenderFns } from "./import-purchase.vue?vue&type=template&id=864bc33a&scoped=true"
import script from "./import-purchase.vue?vue&type=script&lang=js"
export * from "./import-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864bc33a",
  null
  
)

export default component.exports